import { render, staticRenderFns } from "./checkboxes.vue?vue&type=template&id=147b74f1&lang=pug&"
import script from "./checkboxes.vue?vue&type=script&lang=js&"
export * from "./checkboxes.vue?vue&type=script&lang=js&"
import style0 from "./checkboxes.vue?vue&type=style&index=0&id=147b74f1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports